import { Product } from 'state/product'
import { Color } from 'state/color'

MK.events.on('products:refine', (event = {}) => {
  const active = event.target
  // function (active) { // , start = performance.now()
  // console.log('DEBUG (MK.product.refine) Starting product refinement.', active)

  Object.values(Color.by.alias).forEach(color => color.is.active = active.aliases.has(color.alias) && active.productIDs.has(color.productID))

  Object.values(Product.index.skus).forEach(sku => sku.is.active = active.aliases.has(sku.alias) && active.productIDs.has(sku.productID))
  Object.values(Product.index.skus).forEach(sku => sku.isActive())

  Object.values(Product.index.ids).forEach(product => product.is.active = active.productIDs.has(product.id))
  Object.values(Product.index.ids).forEach(product => product.isActive())

  MK.events.emit('products:updateDOM', {
    initiator: 'products:refine'
  })

  MK.events.emit('attribute:groups:updateDOM', {
    initiator: 'products:refine'
  })
  // console.log(`DEBUG (MK.product.refine) Product refinement took ${(performance.now() - start)} milliseconds.`)

})